module.exports = __webpack_public_path__ + "img/mesLogo.60a7f9c5.png";